<template lang="pug">
  .b2b-page-accountingclose-drafts
    ods-module
      div(slot='header')
        ods-row.info(type='flex', align='middle')
          ods-col(:span='8')
            div {{ $t('msg_generics.information') }}
      ods-form(
        ref='draftDetailForm',
        :model='draftDetailForm',
        label-width='14rem',
        label-position='left',
        size='mini',
        status-icon)
        ods-row(type='flex')
          ods-col(:span='10')
            ods-form-item(
              prop='projectName',
              :label='$t("accounting_closes.entity_table.project")')
              ods-input(
                :disabled='true',
                v-model="draftDetailForm.projectName")
            ods-form-item(
              prop='buyerName',
              :label='$t("accounting_closes.entity_table.buyer")')
              ods-input(
                :disabled='true',
                v-model="draftDetailForm.buyerName")
            ods-form-item(
              prop='name',
              :label='$t("accounting_closes.entity_table.name")')
              ods-input(
                :disabled='true',
                v-model="draftDetailForm.name")
            ods-form-item(
              prop='closeDateTime',
              :label='$t("accounting_closes.entity_table.close_date_time")')
              ods-input(
                :disabled='true',
                v-model="closeDateTimeFormatted")
          ods-col(:span='4')
          ods-col(:span='10')
            ods-form-item(
              prop='status',
              :label='$t("accounting_closes.entity_table.status")')
              ods-input(
                :disabled='true',
                v-model="statusFormatted")
            ods-form-item(
              prop='startDate',
              :label='$t("accounting_closes.entity_table.start_date")')
              ods-input(
                :disabled='true',
                v-model="startDateFormatted")
            ods-form-item(
              prop='endDate',
              :label='$t("accounting_closes.entity_table.end_date")')
              ods-input(
                :disabled='true',
                v-model="endDateFormatted")
            ods-form-item(
              prop='childAccountingCloseName',
              :label='$t("accounting_closes.entity_table.child_accounting_close_name")')
              ods-input(
                :disabled='true',
                v-model="draftDetailForm.childAccountingCloseName")

    ods-module.collapse
      ods-accordion(v-model='activateInvoices',@change='')
        ods-accordion-item(name='1')
          template(slot='title')
            span  {{ $t('accounting_closes_detail.invoices.title') }}
            span.info(v-show='!invoices.length') {{ $t('accounting_closes_detail.invoices.no_data') }}

          //- Tabla facturas asociadas a un cierre contable
          ods-table(
            v-if='invoices.length > 0 ',
            :data='invoices',
            :default-sort="{prop: 'id', order: 'ascending'}",
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnter',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='buyerName',
              :label='$t("accounting_closes_detail.invoices.buyer")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='sellerName',
              :label='$t("accounting_closes_detail.invoices.seller")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='invoiceNumber',
              :label='$t("accounting_closes_detail.invoices.invoice_number")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='issueDate',
              :label='$t("accounting_closes_detail.invoices.issue_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='creationDateTime',
              :label='$t("accounting_closes_detail.invoices.creation_date_time")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='totalExecutableAmount',
              :label='$t("accounting_closes_detail.invoices.total_executable_amount")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='currencyCode',
              :label='$t("accounting_closes_detail.invoices.currency")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='status',
              :label='$t("accounting_closes_detail.invoices.status")',
              :show-overflow-tooltip='true',
              :formatter='formatterStatusInvoice',
              sortable='')
            ods-table-column(
              prop='projectName',
              :label='$t("accounting_closes_detail.invoices.project")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='receptionMethod',
              :label='$t("accounting_closes_detail.invoices.reception_method")',
              :show-overflow-tooltip='true',
              :formatter='formatterCommunicationMethod',
              sortable='')
            ods-table-column(
              width='100'
              align='center',
              :label='$t("order.order_entity_table_detail.options")'
              :show-overflow-tooltip='true'
              sortable='')
              template(slot-scope="scope")
                ods-tooltip(:content='$t("invoice_detail.buttons.download_invoice_tooltip")', placement='bottom')
                  ods-button(
                    type='neutral',
                    @click.native='handleDownloadInvoicePdf(scope.row, scope)')
                    ods-icon(name='download', size='16', circle)
                ods-tooltip(:content='$t("invoices.tooltip.attachments")', placement='bottom')
                  ods-button(
                    type='neutral',
                    v-if="scope.row.withAttachment!==null && scope.row.withAttachment && canSeeAttachments",
                    @click.native='handleShowSeeAttachments(scope.row, scope)')
                    ods-icon(name='clip', size='16', circle)
                ods-tooltip(:content='$t("invoices.tooltip.events")', placement='bottom')
                  ods-button(
                    type='neutral',
                    v-if="canSeeEvents",
                    @click.native='handleShowSeeEvents(scope.row, scope)')
                    ods-icon(name='clock', size='16', circle)
          ods-row.b2b-table-facturas-recibidas__pagination()
            ods-col.b2b-table-facturas-recibidas__pagination--right(:span='20')
              ods-pagination(
                ref='paginationInvoices',
                popper-class='b2b-pagination__dropdown',
                @size-change='pageInvoicesSizeChanged',
                @current-change='currentPageInvoicesChanged',
                :current-page.sync='paginationInvoices.currentPage',
                :page-sizes='[20, 50, 100]',
                :page-size='paginationInvoices.pageSize',
                layout='total, sizes, prev, pager, next, slot',
                :total='paginationInvoices.totalElements')
    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          v-if='isShowSeeAttachments',
          name='1')
          template(slot='title')
            span {{ $t('invoice_detail.attachment') }}
            span.info(v-show='!attachments.length') {{ $t('invoice_detail.no_attachment') }}
          //- Tabla de Adjuntos
          ods-table(
            v-if='attachments.length > 0 ',
            :data='attachments',
            :default-sort='{ prop: "creationDate", order: "descending" }',
            style='width: 100%',
            @cell-mouse-enter='handleCellMouseEnterAttach',
            highlight-current-row,
            size='mini',
            fit)
            ods-table-column(
              prop='filename',
              :label='$t("invoice_detail.attachments_table.filename")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              prop='category',
              :label='$t("invoice_detail.attachments_table.category")',
              :show-overflow-tooltip='true',
              :formatter= 'formatterCategory',
              sortable='')
            ods-table-column(
              prop='size',
              :label='$t("invoice_detail.attachments_table.size")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='compressedSize',
              :label='$t("invoice_detail.attachments_table.compressed_size")',
              align='right',
              :show-overflow-tooltip='true',
              :formatter='formatterKBSize',
              sortable='')
            ods-table-column(
              prop='creationDate',
               width='110',
              :label='$t("invoice_detail.attachments_table.creation_date")',
              align='center',
              :show-overflow-tooltip='true',
              :formatter='formatterDate',
              sortable='')
            ods-table-column(
              prop='author',
              :label='$t("invoice_detail.attachments_table.author")',
              :show-overflow-tooltip='true',
              sortable='')
            ods-table-column(
              width='80',
              align='center',
              :label='$t("order.order_entity_table_detail.options")'
              :show-overflow-tooltip='true')
              template(slot-scope='scope')
                ods-button.first-button(
                  type='neutral',
                  @click='downloadAttachment')
                  ods-icon(name='download', size='16')
    ods-module.collapse
      ods-accordion(v-model='activateLines', @change='')
        ods-accordion-item(
          v-if='isShowSeeEvents',
          name='2')
          template(slot='title')
            span {{ $t('invoice_detail.events.title') }}
            span.info(v-show='!events.length') {{ $t('msg_generics.no_match') }}
            i(class='header-icon el-icon-information')
          ods-row()
            b2b-timeline(:events='events')
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import moment from 'moment'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-page-accountingclose-drafts',
  mixins: [Utils],
  data () {
    return {
      paginationInvoices: {
        currentPage: 0,
        totalElements: 0,
        pageSize: 20
      },
      tableInvoiceSort: {
        prop: 'id',
        order: 'descending'
      },
      activateLines: ['1', '2'],
      activateInvoices: ['1'],
      // Facturas asociadas a un cierre contable
      invoices: [],
      draftId: null,
      invoiceId: null,
      searchType: 'RECEIVED',
      draftDetailForm: {
        projectName: null,
        buyerName: null,
        name: null,
        status: null,
        closeDateTime: null,
        startDate: null,
        endDate: null,
        childAccountingCloseName: null
      },
      currentRow: {},
      isShowSeeAttachments: false,
      isShowSeeEvents: false,
      // ADJUNTOS
      attachments: [],
      currentRowAttachments: {},
      fileList: [],
      // EVENTOS
      events: [],
      queryParams: {}
    }
  },

  components: {
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      // Permisos
      'canRejectRecadv',
      'canModifyRecadv',
      'canSeeAttachments',
      'canSeeEvents'
    ]),

    closeDateTimeFormatted () { // eslint-disable-line
      if (this.draftDetailForm.closeDateTime) {
        const date = new Date(this.draftDetailForm.closeDateTime)
        return this.$d(date, 'long')
      }
    },

    statusFormatted () {
      return this.$t('status_accounting_close.' + this.draftDetailForm.status)
    },

    startDateFormatted () { // eslint-disable-line
      if (this.draftDetailForm.startDate) {
        const date = new Date(this.draftDetailForm.startDate)
        return this.$d(date, 'long')
      }
    },

    endDateFormatted () { // eslint-disable-line
      if (this.draftDetailForm.endDate) {
        const date = new Date(this.draftDetailForm.endDate)
        return this.$d(date)
      }
    }
  },

  methods: {
    ...mapActions([
      'getAccountingClose',
      'getAccountinCloseInvoiceNotes',
      'deleteAccountingClosesDraft',
      'handleDownloadMultiInvoiceNotesPdf',
      'getInvoiceNoteAttachments',
      'downloadInvoiceNoteAttachment',
      'getInvoiceNoteEvents'
    ]),

    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },
    formatterCategory (row, column) {
      return row[column.property] ? this.$t('auditory_detail.events.code.' + row[column.property]) : ' '
    },
    formatterStatusInvoice (row, column) {
      if (row[column.property]) {
        return this.$t('invoice_status.' + row[column.property])
      }
    },
    // Formatear metodo de envio
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },

    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },
    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    async getAccountingCloseOnDatabase () {
      try {
        const draft = await this.getAccountingClose(this.draftId)
        this.draftDetailForm = draft
      } catch (error) {
        console.log('getAccountingCloseOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    checkTablePaginationInvoices (size, page, totalElements) {
      this.paginationInvoices = {
        currentPage: totalElements > 0 ? page + 1 : 0,
        totalElements: totalElements,
        pageSize: size
      }
    },
    cleanResultsInvoices () {
      this.invoices = {
        content: [],
        first: true,
        last: true,
        number: 0,
        numberOfElements: 0,
        size: 0,
        sort: {
          direction: 'DESC',
          field: 'id'
        },
        totalElements: 0,
        totalPages: 0
      }
    },
    checkTableSortInvoices (sort) {
      if (
        sort === null ||
      sort === undefined ||
      sort.field === null ||
      sort.field === undefined
      ) {
        this.tableInvoiceSort = {
          prop: null,
          order: null
        }
      // this.$refs.invoices.clearSort()
      } else {
        const sortAux = {
          prop: sort.field,
          order: sort.direction === 'ASC' ? 'ascending' : 'descending'
        }
        if (
          sortAux.prop !== this.tableInvoiceSort.prop ||
        sortAux.order !== this.tableInvoiceSort.order
        ) {
          this.tableInvoiceSort = sortAux
          // this.$refs.invoices.clearSort()
          this.$refs.invoices.sort(
            this.tableInvoiceSort.prop,
            this.tableInvoiceSort.order
          )
        }
      }
    },
    async currentPageInvoicesChanged (page) {
      if (this.loading) {
        return
      }
      this.paginationInvoices.currentPage = page
      await this.doSearchInvoices(this.$t('msg_generics.pagination_table'))
    },
    async pageInvoicesSizeChanged (size) {
      if (this.loading) {
        return
      }
      this.paginationInvoices.pageSize = size
      await this.doSearchInvoices(this.$t('msg_generics.size_table'))
    },
    async doSearchInvoices (loadingText) {
      if (this.loading) {
        return false
      }
      this.loading = true
      const load = this.$loading({
        lock: true,
        text: loadingText
      })
      this.cleanResultsInvoices()
      try {
        this.isShowInvoicesList = true
        this.activateLines = ['2']

        if (this.queryParams === null || this.queryParams === undefined) {
          this.queryParams = {}
        }
        this.queryParams.draftId = this.draftId
        this.queryParams.size = this.paginationInvoices.pageSize
        this.queryParams.page =
          this.paginationInvoices.currentPage > 0
            ? this.paginationInvoices.currentPage - 1
            : undefined
        this.queryParams.sort =
          this.tableInvoiceSort.prop != null
            ? this.tableInvoiceSort.prop +
              ',' +
              (this.tableInvoiceSort.order === 'ascending' ? 'ASC' : 'DESC')
            : undefined

        const facturas = await this.getAccountinCloseInvoiceNotes(this.queryParams)
        this.invoices = facturas.content
        this.invoices.size = facturas.size
        this.invoices.number = facturas.number
        this.invoices.totalElements = facturas.totalElements

        this.checkTableSortInvoices(this.invoices.sort)
        this.checkTablePaginationInvoices(
          this.invoices.size,
          this.invoices.number,
          this.invoices.totalElements
        )
        console.log('doSearchInvoices RESULT: ', this.invoices)
      } catch (error) {
        console.error('doSearchInvoices CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.loading = false
      }
    },
    handleCellMouseEnterAttach (row, column, cell, event) {
      this.currentRowAttachments = row
    },
    // Descarga de pdf
    async handleDownloadInvoicePdf (row, scope) {
      console.log('handleDownloadInvoicePdf: ', row.id)
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })

      try {
        const idList = [row.id]
        const filename = await this.handleDownloadMultiInvoiceNotesPdf({
          invoiceNoteId: idList,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('handleDownloadInvoicePdf CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Ver eventos
    async handleShowSeeEvents (row, scope) {
      console.log('handleShowSeeEvents: ', row.id)
      if (this.invoiceId === row.id) {
        this.isShowSeeEvents = !this.isShowSeeEvents
        if (this.isShowSeeAttachments) {
          this.activateLines = ['1']
        }
        if (this.isShowSeeEvents && this.isShowSeeAttachments) {
          this.activateLines = ['1', '2']
        } else if (this.isShowSeeEvents) {
          this.activateLines = ['2']
        }
      } else {
        this.invoiceId = row.id
        this.isShowSeeEvents = true
        this.isShowSeeAttachments = false
      }
      try {
        if (this.isShowSeeEvents) {
          await this.getInvoiceNoteEventsOnDatabase(this.invoiceId)
        }
      } catch (error) {
        console.log('handleShowSeeEvents CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // Ver adjuntos
    async handleShowSeeAttachments (row, scope) {
      console.log('showSeeAttachments: ', row.id)
      if (this.invoiceId === row.id) {
        this.isShowSeeAttachments = !this.isShowSeeAttachments
        if (this.isShowSeeEvents) {
          this.activateLines = ['2']
        }
        if (this.isShowSeeAttachments && this.isShowSeeEvents) {
          this.activateLines = ['1', '2']
        } else if (this.isShowSeeAttachments) {
          this.activateLines = ['1']
        }
      } else {
        this.invoiceId = row.id
        this.isShowSeeAttachments = true
        this.isShowSeeEvents = false
      }
      try {
        if (this.isShowSeeAttachments) {
          await this.getInvoiceNoteAttachmentsOnDatabase()
        }
      } catch (error) {
        console.log('showSeeAttachments CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async downloadAttachment () {
      console.log('downloadAttachment: ', this.invoiceId)
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.download_attachment')
      })
      try {
        const filename = await this.downloadInvoiceNoteAttachment({
          invoiceNoteId: this.invoiceId,
          attachmentId: this.currentRowAttachments.id,
          searchType: this.searchType
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    async getInvoiceNoteAttachmentsOnDatabase () {
      // Get Adjuntos
      try {
        const params = {
          invoiceNoteId: this.invoiceId,
          searchType: this.searchType
        }
        this.attachments = await this.getInvoiceNoteAttachments(params)
      } catch (error) {
        console.log('getInvoiceNoteAttachmentsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    // EVENTOS
    async getInvoiceNoteEventsOnDatabase (invoiceId) {
      try {
        this.events = await this.getInvoiceNoteEvents({
          invoiceNoteId: invoiceId,
          searchType: this.searchType
        })
      } catch (error) {
        console.log('getInvoiceNoteeventsOnDatabase CATCH: ', error)
        this.getNotificationErrorMessage(error)
      }
    },
    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null
      statusCode = error.status
      switch (statusCode) {
        case 400:
        case 409:
          if (error.data.message) {
            errorSms = error.data.message
          }
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      if (!errorSms && error.config.responseType === 'blob') {
        errorSms = this.$t('msg_generics.error_download_pdf')
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      this.draftId = (this.$route.params && this.$route.params.draftId ? this.$route.params.draftId : null)
      await this.getAccountingCloseOnDatabase()
      await this.doSearchInvoices()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.b2b-page-accountingclose-drafts {
  padding: 40px 40px 40px 40px;

  ::v-deep .ods-module {
    &__header {
      background-color: var(--color-bg-hover-2);
      padding: 0px;
      .info {
        margin-left: 40px;
        margin-right: 40px;
        height: 72px;
        color: var(--color-bg-interactive);
        size: 16px;
        line-height: 24px;
      }
    }

    &__body {
      padding: 32px;
      .info {
        padding-bottom: 32px;
      }
    }
  }

  .form-actions {
    padding-top: 40px;
    padding-bottom: 40px;
    .ods-button {
      float: right;
    }
  }
  .ods-button:not(.is-circle) i, .ods-button:not(.is-circle) [class*="ods-icon-"], .ods-button:not(.is-circle) [class*=" ods-icon-"] {
      margin-top: -2px;
      margin-left: 0px;
  }
  .collapse {
    margin-top: 25px;
    border-bottom: 0px;
    .info {
      margin-left: 1rem;
      color: var(--color-txt-secondary);
    }

    ::v-deep .ods-table {
      th {
        padding: rem(0);
        padding-top: rem(4);

        .cell {
          font-weight: 500;
        }
      }
      &__row {
        .ods-button {
          border-color: transparent;
          background-color: transparent;
          color: #2E6C99;
          padding: 0px;
          margin-right: 0px;
          i {
            margin-left: 0px;
          }
        }
        .first-button {
          padding: 0px;
          margin-left: 0px;
          margin-right: rem(12);
          i {
            margin-left: 0px;
          }
        }
      }
    }

    .button-collapse {
      float: right;
    }

    ::v-deep .ods-module{
      &__body{
        padding: 0px;
      }
    }
  }
}
</style>
